/**
 * Canonical paths for augment SVG assets under `/public/augments/`.
 *
 *   augments/{match|clash|round}/{slug}/default.svg
 *   augments/{match|clash|round}/{slug}/styles/{styleId}.svg
 */

export const AUGMENT_ASSET_ROOT = '/augments';

export const AUGMENT_KIND = {
  MATCH: 'match',
  CLASH: 'clash',
  ROUND: 'round'
};

const CLASH_CODES = new Set(['sa', 'bs', 'eif', 'gd']);
const ROUND_CODES = new Set(['os', 'aon', 'gc', 'bus', 'sn', 'bl', 'none']);

/** Directory-safe slug for an augment or store group id. */
export function augmentCodeToAssetSlug(code) {
  if (!code) return code;
  if (code === 'g' || code === '+1h' || code === '+1a' || code === '+1goal') return '1goal';
  if (code === 'hp' || code === 'ap' || code === 'penalty') return 'penalty';
  if (code === 'mph' || code === 'mpa' || code === 'missed-pk') return 'missed-pk';
  if (code === 'rch' || code === 'rca' || code === 'red-card') return 'red-card';
  if (code === 'ph' || code === 'pa' || code === 'shootout') return 'shootout';
  if (code === 'et') return 'et';
  return code;
}

/** @param {string} codeOrSlug */
export function getAugmentKind(codeOrSlug) {
  const slug = augmentCodeToAssetSlug(codeOrSlug);
  if (CLASH_CODES.has(slug)) return AUGMENT_KIND.CLASH;
  if (ROUND_CODES.has(slug)) return AUGMENT_KIND.ROUND;
  return AUGMENT_KIND.MATCH;
}

/**
 * @param {string} codeOrSlug augment code or store group id (`penalty`, `1goal`, …)
 * @param {'match'|'clash'|'round'} [kind]
 */
export function getAugmentDefaultSvgPath(codeOrSlug, kind) {
  const slug = augmentCodeToAssetSlug(codeOrSlug);
  const resolvedKind = kind ?? getAugmentKind(slug);
  return `${AUGMENT_ASSET_ROOT}/${resolvedKind}/${slug}/default.svg`;
}

/**
 * @param {string} codeOrSlug
 * @param {number} styleId
 * @param {'match'|'clash'|'round'} [kind]
 */
export function getAugmentStyleSvgPath(codeOrSlug, styleId, kind) {
  const slug = augmentCodeToAssetSlug(codeOrSlug);
  const resolvedKind = kind ?? getAugmentKind(slug);
  return `${AUGMENT_ASSET_ROOT}/${resolvedKind}/${slug}/styles/${styleId}.svg`;
}

/** Round augment carousel “none” card. */
export const ROUND_NONE_SVG = getAugmentDefaultSvgPath('none', AUGMENT_KIND.ROUND);
